import moment from "moment";
import React from "react";
import { FormattedMessage } from "react-intl";
import { USER_LOG_ENTRY_TYPES } from "../../../../api/constants";
import { Icon } from "../../../graphic/Icon";
import { ScrollableArea } from "../../../layout/ScrollableArea";
import { Item, ItemList } from "../../../list/ItemList";
import { Badge } from "../../../misc/Badge";
import { TitleDescriptionText } from "../../../typography/TitleDescriptionText";
import { DurationCounter } from "../../DurationCounter";
import styles from "./TimeLogList.scss";

const msgKey = "timeLogList";

export const TimeLogList = ({ busy, entries, onClickEntry }) => {
    return (
        <div className={styles.base}>
            <ScrollableArea suppressScrollX>
                <div className={styles.content}>
                    <ItemList
                        busy={busy}
                        onItemClick={(val) => onClickEntry(val)}
                        emptyMessage={<FormattedMessage id={`${msgKey}.noRegisteredHours`} />}
                    >
                        {entries?.map((entry) => (
                            <Item
                                key={entry.id}
                                value={entry}
                                append={[
                                    ...(entry.trip
                                        ? [<Icon key="trip" name="trip" size="small" color="base40" />]
                                        : []),
                                    ...(entry.remarks
                                        ? [<Icon key="comment" name="comment" size="small" color="base40" />]
                                        : []),
                                    <Badge
                                        key="badge"
                                        size="small"
                                        fill
                                        customColor={USER_LOG_ENTRY_TYPES[entry.type].color}
                                    >
                                        <FormattedMessage id={USER_LOG_ENTRY_TYPES[entry.type].shortLabel} />
                                    </Badge>
                                ]}
                            >
                                <TitleDescriptionText
                                    title={<DurationCounter ranges={[{ from: entry.startTime, to: entry.endTime }]} />}
                                    description={
                                        <>
                                            {moment(entry.startTime).format("lll")}
                                            &nbsp;-&nbsp;
                                            {entry.endTime ? (
                                                moment(entry.endTime).format("lll")
                                            ) : (
                                                <FormattedMessage id={`${msgKey}.notSet`} />
                                            )}
                                        </>
                                    }
                                />
                            </Item>
                        ))}
                    </ItemList>
                </div>
            </ScrollableArea>
        </div>
    );
};
